var Dropdowns = ["Model", "Bodystyle","Year"];
	var Data ={
         "phones": [
 {
   "level1": "CitiGo",
   "level2": "City Car",
   "level3": "2012 to present",
   "price": "skoda_citigo_citycar_2012_to_present"
 },
{
   "level1": "Elroq",
   "level2": "SUV",
   "level3": "2025 to present",
   "price": "SKODA_Elroq_SUV_2025_to_present"
 },
 {
   "level1": "Enyaq EV",
   "level2": "SUV",
   "level3": "2022 to present",
   "price": "skoda_enyaq_ev_suv_2021_to_present"
 },
 {
   "level1": "Epiq",
   "level2": "SUV",
   "level3": "2027",
   "price": "SKODA_Epiq_SUV_2027_to_present"
 },
 {
   "level1": "Fabia",
   "level2": "Estate",
   "level3": "1999 to 2008",
   "price": "skoda_fabia_estate_1999_to_2008"
 },
 {
   "level1": "Fabia",
   "level2": "Estate",
   "level3": "2007 to 2010",
   "price": "skoda_fabia_estate_2007_to_2010"
 },
 {
   "level1": "Fabia",
   "level2": "Estate",
   "level3": "2010 to 2014",
   "price": "skoda_fabia_estate_2010_to_2014"
 },
 {
   "level1": "Fabia",
   "level2": "Estate",
   "level3": "2014 to 2022",
   "price": "skoda_fabia_estate_2014_to_2022"
 }, 
  {
   "level1": "Fabia",
   "level2": "Estate",
   "level3": "2022 to present",
   "price": "skoda_fabia_estate_2022_to_present"
 },
 {
   "level1": "Fabia",
   "level2": "Hatchback",
   "level3": "1999 to 2008",
   "price": "skoda_fabia_hatchback_1999_to_2008"
 },
 {
   "level1": "Fabia",
   "level2": "Hatchback",
   "level3": "2007 to 2010",
   "price": "skoda_fabia_hatchback_2007_to_2010"
 },
 {
   "level1": "Fabia",
   "level2": "Hatchback",
   "level3": "2010 to 2014",
   "price": "skoda_fabia_hatchback_2010_to_2014"
 },
 {
   "level1": "Fabia",
   "level2": "Hatchback",
   "level3": "2014 to 2022",
   "price": "skoda_fabia_hatchback_2014_to_2022"
 },
 {
   "level1": "Fabia",
   "level2": "Hatchback",
   "level3": "2022 to present",
   "price": "skoda_fabia_hatchback_2022_to_present"
 },
 {
   "level1": "Fabia",
   "level2": "Saloon",
   "level3": "1999 to 2008",
   "price": "skoda_fabia_saloon_1999_to_2008"
 },
 {
   "level1": "Kamiq",
   "level2": "SUV",
   "level3": "2019 to present",
   "price": "skoda_kamiq_suv_2019_to_present"
 },
 {
   "level1": "Karoq",
   "level2": "SUV",
   "level3": "2017 to 2021",
   "price": "skoda_karoq_suv_2017_to_2021"
 },     
{
   "level1": "Karoq",
   "level2": "SUV",
   "level3": "2022 to present",
   "price": "skoda_karoq_suv_2022_to_present"
 },
 {
   "level1": "Kodiaq",
   "level2": "SUV",
   "level3": "2017 to 2024",
   "price": "skoda_kodiaq_suv_2017_to_2024"
 },
           {
   "level1": "Kodiaq",
   "level2": "SUV",
   "level3": "2024 to present",
   "price": "skoda_kodiaq_suv_2024_to_present"
 },
 {
   "level1": "Octavia",
   "level2": "Estate",
   "level3": "2004 to 2008",
   "price": "skoda_octavia_estate_2004_to_2008"
 },
 {
   "level1": "Octavia",
   "level2": "Estate",
   "level3": "2008 to 2013",
   "price": "skoda_octavia_estate_2008_to_2013"
 },
 {
   "level1": "Octavia",
   "level2": "Estate",
   "level3": "2013 to 2017",
   "price": "skoda_octavia_estate_2013_to_2017"
 },
 {
   "level1": "Octavia",
   "level2": "Estate",
   "level3": "2017 to 2020",
   "price": "skoda_octavia_estate_2017_to_2020"
 },
 {
   "level1": "Octavia",
   "level2": "Estate",
   "level3": "2020 to 2024",
   "price": "skoda_octavia_estate_2020_to_2024"
 },
 {
   "level1": "Octavia",
   "level2": "Estate",
   "level3": "2024 to present",
   "price": "skoda_octavia_estate_2024_to_present"
 },        
 {
   "level1": "Octavia",
   "level2": "Hatchback",
   "level3": "2004 to 2008",
   "price": "skoda_octavia_hatchback_2004_to_2008"
 },
 {
   "level1": "Octavia",
   "level2": "Hatchback",
   "level3": "2008 to 2013",
   "price": "skoda_octavia_hatchback_2008_to_2013"
 },
 {
   "level1": "Octavia",
   "level2": "Hatchback",
   "level3": "2013 to 2017",
   "price": "skoda_octavia_hatchback_2013_to_2017"
 },
 {
   "level1": "Octavia",
   "level2": "Hatchback",
   "level3": "2017 to 2020",
   "price": "skoda_octavia_hatchback_2017_to_2020"
 },
 {
   "level1": "Octavia",
   "level2": "Hatchback",
   "level3": "2020 to 2024",
   "price": "skoda_octavia_hatchback_2020_to_2024"
 },
 {
   "level1": "Octavia",
   "level2": "Hatchback",
   "level3": "2024 to present",
   "price": "skoda_octavia_hatchback_2024_to_present"
 },
  {
   "level1": "Peaq",
   "level2": "SUV",
   "level3": "2027",
   "price": "SKODA_peaq_SUV_2027_to_present"
 },
 {
   "level1": "Rapid",
   "level2": "Hatchback",
   "level3": "2013 to 2017",
   "price": "skoda_rapid_hatchback_2013_to_2017"
 },
 {
   "level1": "Rapid",
   "level2": "Saloon",
   "level3": "2012 to 2016",
   "price": "skoda_rapid_saloon_2012_to_2016"
 },
 {
   "level1": "Roomster",
   "level2": "MPV",
   "level3": "2006 to 2010",
   "price": "skoda_roomster_mpv_2006_to_2010"
 },
 {
   "level1": "Roomster",
   "level2": "MPV",
   "level3": "2010 to 2015",
   "price": "skoda_roomster_mpv_2010_to_2015"
 },
 {
   "level1": "Scala",
   "level2": "Hatchback",
   "level3": "2019 to present",
   "price": "skoda_scala_hatchback_2019_to_present"
 },
 {
   "level1": "Superb",
   "level2": "Estate",
   "level3": "2015 to 2024",
   "price": "skoda_superb_estate_2015_to_2024"
 },
 {
   "level1": "Superb",
   "level2": "Estate",
   "level3": "2024 to present",
   "price": "skoda_superb_estate_2024_to_present"
 },          
 {
   "level1": "Superb",
   "level2": "Hatchback",
   "level3": "2008 to 2013",
   "price": "skoda_superb_hatchback_2008_to_2013"
 },
 {
   "level1": "Superb",
   "level2": "Hatchback",
   "level3": "2013 to 2015",
   "price": "skoda_superb_hatchback_2013_to_2015"
 },
 {
   "level1": "Superb",
   "level2": "Hatchback",
   "level3": "2015 to 2024",
   "price": "skoda_superb_hatchback_2015_to_present"
 },
 {
   "level1": "Superb",
   "level2": "Hatchback",
   "level3": "2024 to present",
   "price": "skoda_superb_hatchback_2024_to_present"
 },
 {
   "level1": "Superb",
   "level2": "Saloon",
   "level3": "2001 to 2008",
   "price": "skoda_superb_saloon_2001_to_2008"
 },
 {
   "level1": "Superb",
   "level2": "Saloon",
   "level3": "2008 to 2013",
   "price": "skoda_superb_saloon_2008_to_2013"
 },
 {
   "level1": "Superb",
   "level2": "Saloon",
   "level3": "2013 to 2015",
   "price": "skoda_superb_saloon_2013_to_2015"
 },
 {
   "level1": "Yeti",
   "level2": "SUV",
   "level3": "2009 to 2013",
   "price": "skoda_yeti_suv_2009_to_2013"
 },
 {
   "level1": "Yeti",
   "level2": "SUV",
   "level3": "2013 to present",
   "price": "skoda_yeti_suv_2013_to_present"
 }
]
};

$(document).ready(function() {
  var body = $('body')
	var totalDropBox = Dropdowns.length;
	var allDropDownData ="";
	var activeDroplength=0;
	var matchedVal=0;
	var arrayDrop1=[];
  var activeTotalDropBox=[];
  var steptitle = 'Step';
  var selectvehicle = 'Select Vehicle';
	for (var i=1;i<=totalDropBox;i++) {
		allDropDownData+='<div data-active="inactive" class="configDropDown" id="level'+i+'"><span class="oa-vf__dropdown--number">'+i+'</span><span data-label="model" class="configDropDownSelect">'+Dropdowns[i-1]+'</span><span class="dropArrow"></span><div class="vehicles-wrap"><div class="vehicles-wrap__mobile-header"><span class="step">'+steptitle+' '+i+'</span><h4 class="step-title">'+selectvehicle+' '+Dropdowns[i-1]+'<h4></div><ul class="oa-vf__dropdown-content--'+i+'"></ul></div></div>';
	}
	$(".configuratorWrap").html(allDropDownData + '<div class="oa-vf__cta-holder"><button class="CtaButton btn btn--wide disabled"><a id="model-search-1" data-vehicle-history data-garage="" href="">Select & Save Model</a></button></div>');
	var firstDropDownData ="";
	$.each(Data.phones, function(index, value) {
		if (firstDropDownData.indexOf("<li>"+ value.level1 +"<span></span></li>") <0) {
			firstDropDownData=firstDropDownData+"<li>"+ value.level1 +"<span></span></li>";
		}
	});
	$("#level1 ul").html(firstDropDownData);
	$(".configDropDown").addClass("configDropDownDisabled");
	$(".configDropDown").eq(0).removeClass("configDropDownDisabled");
	$("body").on('click', '.configDropDown', function(e){
		e.stopPropagation();
		if ($(this).attr("data-active")=="inactive") {
			$(".configDropDown .vehicles-wrap").removeClass('open');
			$(".configDropDown").attr("data-active","inactive");
			$(".disabledSelector").css("display","none");
			$(this).find(".vehicles-wrap").addClass('open');
			if($(this).find(".vehicles-wrap ul li").length)
			{
				$(this).find(".disabledSelector").css("display","block");
			}
			$(this).attr("data-active","active");
			
		}
		else if ($(this).attr("data-active")=="active")
		{
			$(this).find(".vehicles-wrap").removeClass('open');
			$(this).find(".disabledSelector").css("display","none");
			$(this).attr("data-active","inactive");
			
		}
    });
	$("body").click(function(){
		$(".configDropDown .vehicles-wrap").removeClass('open');
		$(".configDropDown").attr("data-active","inactive");
		$(".disabledSelector").css("display","none");
	});
	$("body").on('click', '.configDropDown .vehicles-wrap ul li', function(e){
		var currentLevelIndex=$(this).parents(".configDropDown").index()+1;
		var nextLevelIndex=$(this).parents(".configDropDown").index()+2;
		$(this).parents(".configDropDown").find(".configDropDownSelect").html($(this).text().trim());
		var currentDropdownText=$(this).parents(".configDropDown").find(".configDropDownSelect").text().trim();
		if (activeTotalDropBox.toString().indexOf($(this).parents(".configDropDown").attr("id")) > -1) 
		{
			arrayDrop1[currentLevelIndex-1]=$(this).text().trim();
			activeTotalDropBox[currentLevelIndex-1]= $(this).parents(".configDropDown").attr("id");
            arrayDrop1.splice(currentLevelIndex,arrayDrop1.length - currentLevelIndex);
			for (var i = currentLevelIndex + 1; i <= totalDropBox; i++) {
				$("#level"+i).find("ul").html("");
                $("#level"+i).addClass("configDropDownDisabled");
			}
		}
		else
		{
			arrayDrop1.push(currentDropdownText);
			activeTotalDropBox.push($(this).parents(".configDropDown").attr("id"));
        }
        if($(".configDropDown").hasClass("configDropDownDisabled") || $('configDropDown').attr("data-active")=="active"){
            $(".CtaButton").addClass("disabled")
        }
        else {
            $(".CtaButton").removeClass("disabled")
        }
		if($(".configDropDown").length == currentLevelIndex)
		{
			for(index in Data.phones) {
				for(var k=1;k<=totalDropBox;k++)
				{
					if($("#level"+k).find(".configDropDownSelect").text().trim()==Data.phones[index]["level"+k])
					{
						matchedVal++;
					}
				}
				if (matchedVal==totalDropBox) 
				{
                    let url = window.location.href
                    $(".price").html(Data.phones[index]["price"]);
              
                    if(body.hasClass('template-collection')) {
                      collectionurl = body.data('collection-handle');
                      $(".CtaButton a").attr("href", collectionurl + "/" + Data.phones[index]["price"]);
                    }
                    else if(body.hasClass('template-index') || body.hasClass('template-page')) {
                      $(".CtaButton a").attr("href", "/collections/all/" + Data.phones[index]["price"]);
                    }
                    else if(body.hasClass('template-search')) {
                     $(".CtaButton a").attr("href", url + "+" + Data.phones[index]["price"]);
                     }
                     else {
                    $(".CtaButton a").attr("href", "?model-set=" + Data.phones[index]["price"]);
                     }
                    $('.CtaButton a').attr("data-garage", Data.phones[index]["price"]);
				}
				matchedVal=0;
			}
		}
		else
		{
			activeDroplength = $(".configDropDown").length - $(".configDropDownDisabled").length;
			var tempDropDownData="";
			var currentLevel="";
			var tempVal="";
			for(index in Data.phones) {
				var arrayDrop2=[];
				for(var j=1;j<=activeDroplength;j++)
				{
					currentLevel="level"+(j+1);
					arrayDrop2.push(Data.phones[index]["level"+j]);
					if(currentLevel==$("#level"+nextLevelIndex).attr("id") && arrayDrop1.toString() == arrayDrop2.toString())
					{
						if (tempDropDownData.indexOf("<li>"+ Data.phones[index][currentLevel] +"<span></span></li>") <0) 
						{
							tempDropDownData=tempDropDownData+"<li>"+ Data.phones[index][currentLevel] +"<span></span></li>";
						}
					}
				}
				tempVal=arrayDrop2.toString();
				var arrayDrop2=[];
			}
			 $("#level"+nextLevelIndex).find(".vehicles-wrap").addClass('open');
             $("#level"+nextLevelIndex).attr("data-active","active");
			$("#level"+nextLevelIndex+" ul").html(tempDropDownData);
			$("#level"+nextLevelIndex).removeClass("configDropDownDisabled");
			$(this).parents(".configDropDown").find(".configDropDownSelect").html($(this).text().trim());
		}
	});
});